import { createAction, props } from '@ngrx/store';
import { CompanyMetaData } from 'domain-entities';

export const setCompanyMetaData = createAction(
	'[Company Metadata] set company metadata',
	props<CompanyMetaData>(),
);

export const clearCompanyMetaData = createAction('[Company Metadata] clear company metadata');
